import { post } from "./request";

// 事件上报
export const postEvent = (data) => {
  return post(
    `/engine/base/smile/track/event?eventType=${data.eventType}&businessId=${data.businessId}`,
  );
};
